
//use function create frame to create bg for the label



import { createMovieClip } from "../../functions/Functions_General";

export class BonusLabelChristmasJoyUI {
  private parent: PIXI.Container = new PIXI.Container();
  private nullParent: PIXI.Container = new PIXI.Container();
  private bgParent: PIXI.Container = new PIXI.Container();

  private bgParentFrame: PIXI.Container = new PIXI.Container();
  private bgParentOverLay: PIXI.Container = new PIXI.Container();

  private textContainer:PIXI.Container = new PIXI.Container();
  private textDisplayValue: PIXI.Text;
  private textDisplayLabel: PIXI.Text;
  private label: string;
  private currency: string;
  //--styling
  private bgCenter: PIXI.Sprite;
  private bgRight: PIXI.Sprite;
  private bgLeft: PIXI.Sprite;
  private frameOffsetSide: number = 20;
  private bgFill:PIXI.Graphics= new PIXI.Graphics().beginFill(0x000000).drawRect(-5,-30,10,60).endFill();

  //-animation
  private animatedOverlay:PIXI.extras.AnimatedSprite;
  private overLayOffsetX:number=70;
  private overLayOffsetY:number=30;
  private align:string="center";//"left and eight"
  private alignement:Array<string>=["left","center","right"];

  private fixedWith:number;
  private bgCenterScaleXMultiplier:number=1;
  // private animatedOverlay:PIXI.Sprite;

  constructor(
    parent: PIXI.Container,
    fontName: string | Array<string>,
    label: string,
    currency: string,
    isCurrencyVisible: boolean
  ) {
    parent.addChild(this.parent);
    this.parent.addChild(this.nullParent);
    
    this.nullParent.addChild(this.bgParent);
    this.bgParent.addChild( this.bgParentFrame);
    this.bgParent.addChild( this.bgParentOverLay);

    this.nullParent.addChild(this.textContainer);
    ///-create text
    let styletext = new PIXI.TextStyle({
      fontFamily: fontName, //"Arial Black",
      dropShadow: true,
      dropShadowAngle: 0,
      dropShadowBlur: 10,
      dropShadowColor: "#ffe229",
      dropShadowDistance: 0,
      fill: ["white", "#feef90"],
      fontSize: 55,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 8,
      whiteSpace: "normal",
      wordWrapWidth: 1000,
    });

    let styletextlabel = new PIXI.TextStyle({
      fontFamily: fontName, //"Arial Black",
      dropShadow: true,
      dropShadowAngle: 0,
      dropShadowBlur: 10,
      dropShadowColor: "#ffe229",
      dropShadowDistance: 0,
      fill: ["white", "#feef90"],
      fontSize: 30,
      fontWeight: "bold",
      lineJoin: "round",
      strokeThickness: 8,
      whiteSpace: "normal",
      wordWrapWidth: 1000,
    });
    this.label = label;
    this.currency = currency;
    if (isCurrencyVisible == false) {
      this.currency = "";
    }

    this.textDisplayLabel= this.textDisplayValue = new PIXI.Text(
     " "+ this.label+": ",
      styletextlabel
    );
    this.textDisplayValue = new PIXI.Text(
     "0.00" + this.currency,
      styletext
    );
    this.textDisplayLabel.anchor.set(0.5,1.35);
    this.textDisplayValue.anchor.set(0.5);
    this.textContainer.addChild(this.textDisplayLabel);
    this.textContainer.addChild(this.textDisplayValue);
    this.setValue(0);
  }
  public alignLeft=():void=>
  { 
    this.align=this.alignement[0];
  }
  public alignRight=():void=>
  {
    this.align=this.alignement[2];
  }
  public alignCenter=():void=>
  {
    this.align=this.alignement[1];
  }

  private alignAll=():void=>
  {
    if(this.align==this.alignement[1])
    {
      this.nullParent.x=0;
    }
    else if( this.align==this.alignement[0])
    {
      this.nullParent.x=this.nullParent.width/2;
    }
    else if(this.align==this.alignement[2])
    {
      this.nullParent.x=-this.nullParent.width/2;
    }
  }
  public setPosition = (posX: number, posY: number): void => {
    this.parent.x = posX;
    this.parent.y = posY;
  };
  public setValue = (newValue: string | number): void => {
    this.textDisplayValue.text =
    " "
    // + this.label+": "
     + newValue+ this.currency + " ";
 //test only
//  if(typeof(newValue)=="string")
//  {
//    this.textDisplayValue.text =
//    " " + this.label + ": " + "50000.00"+ this.currency + " ";

//  }
    
//  /---
    if (this.bgCenter != undefined) {
      this.frameResize();
    }
    if(this.animatedOverlay!=undefined)
    {
      this.overlayResize();
    }
   
    //-align the box;
    this.alignAll();
  
  };
  public getParent = (): PIXI.Container => {
    return this.parent;
  };
  // public getBgParent = (): PIXI.Container => {
  //   return this.bgParent;
  // };

  public getText = (): PIXI.Text => {
    return this.textDisplayValue; ///allows to re edit the look of text and also change its value and also  allows to get its properties like width etc which can be used to dynamicaly scale things
  };

  public getLabel = (): PIXI.Text => {
    return this.textDisplayLabel; ///allows to re edit the look of text and also change its value and also  allows to get its properties like width etc which can be used to dynamicaly scale things
  };
  public getValueText = (): PIXI.Text => {
    return this.textDisplayValue; ///allows to re edit the look of text and also change its value and also  allows to get its properties like width etc which can be used to dynamicaly scale things
  };

  public setVisible = (bool: boolean): void => {
    // console.log('setVisible',bool)
    if (bool) {
      this.parent.alpha = 1;
      
    if(this.animatedOverlay!=undefined)
    {
      this.animatedOverlay.gotoAndPlay(0);
    }
    
    } else {
      this.parent.alpha = 0;

      if(this.animatedOverlay!=undefined)
      {
        this.animatedOverlay.gotoAndStop(0);
      }
    }

    
    

    // this.parent.alpha = 1;
  };

  public isVisible = (): boolean => {
    return this.parent.alpha == 1;
  };
  public createAnimatedOverlay=(animationFrameName:string,startFrame:number,totalFrames:number):void=>
  {
    this.animatedOverlay= createMovieClip(animationFrameName,startFrame,totalFrames);
    this.animatedOverlay.anchor.set(.5);    
    this.animatedOverlay.blendMode=PIXI.BLEND_MODES.ADD;
    this.bgParentOverLay.addChild(this.animatedOverlay);
    this.animatedOverlay.animationSpeed=0.33;
  }
  public createFrame = (
    centerImageName: string,
    leftSideImageName: string
  ): void => {


    this.bgParentFrame.addChild(this.bgFill);
    this.bgFill.alpha=.65;

    this.bgCenter = new PIXI.Sprite(
      PIXI.Texture.fromFrame(centerImageName + ".png")
    );

 
  
    this.bgParentFrame.addChild(this.bgCenter);

    this.bgLeft = new PIXI.Sprite(
      PIXI.Texture.fromFrame(leftSideImageName + ".png")
    );
    this.bgParentFrame.addChild(this.bgLeft);

    this.bgRight = new PIXI.Sprite(
      PIXI.Texture.fromFrame(leftSideImageName + ".png")
    );
    this.bgParentFrame.addChild(this.bgRight);



    //-set Anchor and scale

    this.bgCenter.anchor.set(0.5);
    this.bgRight.anchor.set(1, 0.5);
    this.bgLeft.anchor.set(1, 0.5);

    this.bgRight.scale.set(-1, 1);

    //-set position and scale based on text
    this.frameResize();
  };
  public setFrameOffset = (newVal: number): void => {
    this.frameOffsetSide = newVal;
  };

  public replaceTextStyleBig=(newStyle:PIXI.TextStyle):void=>
  {
    this.textDisplayValue.style=newStyle;

  }
  public replaceTextStyleSmall=(newStyle:PIXI.TextStyle):void=>
  {
  
    this.textDisplayLabel.style=newStyle;
  }
  private frameResize = (): void => {
    if(this.fixedWith!=undefined)
    {
      this.bgCenter.width = this.fixedWith*this.bgCenterScaleXMultiplier;
    }
    else
    {
      this.bgCenter.width =(this.bgCenter.width+ this.frameOffsetSide)*this.bgCenterScaleXMultiplier;// this.textContainer.width- this.frameOffsetSide;
    }

  
    this.bgRight.x =
      this.bgCenter.width / 2 - this.bgRight.width + this.frameOffsetSide;
    this.bgLeft.x =
      -this.bgCenter.width / 2 + this.bgLeft.width - this.frameOffsetSide;

      this. bgFill.width= (this.bgCenter.width+ this.frameOffsetSide)*this.bgCenterScaleXMultiplier;
  };
  
  private overlayResize=():void=>
  { 


    if(this.fixedWith!=undefined)
    {

      this.animatedOverlay.width = this.fixedWith+this.overLayOffsetX;
    }
    else
    {  this.animatedOverlay.width = this.textContainer.width+this.overLayOffsetX;

    }
  
    this.animatedOverlay.height = this.textContainer.height+this.overLayOffsetY;
    if(this.bgCenter!=undefined)
    {
      this.animatedOverlay.height = this.bgCenter.height+this.overLayOffsetY;
    }
  }
  public getBgCenter=():PIXI.Sprite=>
  {
    return this.bgCenter;
  }
  public setOverlayOffset=(offsetX:number,offsetY:number):void=>
  {
    this.overLayOffsetX=offsetX;
    this.overLayOffsetY=offsetY;
  }
  public setOverlayAnimationSpeed=(newSpeed:number):void=>
  {
    this.animatedOverlay.animationSpeed=(newSpeed)
  }
  public setFixedWith=(newVal:number):void=>
  { 
    //In order to this fixed width to work  the setAlign need to be centered , otherwise it will casuse some issue
    this.fixedWith=newVal;
  }
  public setBgCenterScaleXMultiplier=(newVal:number):void=>
  { 
    //In order to this fixed width to work  the setAlign need to be centered , otherwise it will casuse some issue
    this.bgCenterScaleXMultiplier=newVal;
  }
}
